import React from "react";
//#region  types
import { Amount } from "models/utilTypes/currencyType";
import { WintSuperkollAPIModel as ApiModel, WintSuperkollAPIModel, WintUtilsWebApi } from "wint-api-client/dist/types";
import { User } from "models/propTypes/userProfilePropTypes";
import { TranslationKeys } from "translations";
import { SupplierInvoiceListProps } from "models/propTypes/supplierPropTypes";
import { TableEnums } from "models/enums";
//#endregion
//#region Components
import { CurrencyValueFormatter, TableAsync } from "components/common";
import { IncomingInvoicePaymentStatus, IncomingInvoiceStatusTags } from "components/incomingInvoice";
import { useSupplierService } from "serviceHooks";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { UrlHelper } from "utils/helpers";

const SupplierInvoiceList: React.FC<SupplierInvoiceListProps> = (props) => {
  const supplierService = useSupplierService();
  const { supplierId } = props;

  const filterFunc = React.useCallback(
    (pagination: WintUtilsWebApi.Filter) => supplierService.getInvoices(supplierId, pagination),
    []
  );

  const getItemUrl = (id: number | string) => UrlHelper.formatPath(`/IncomingInvoice/${id}`);

  return (
    <TableAsync<ApiModel.IncomingInvoice>
      properties={{
        invoiceDate: {
          description: TranslationKeys.Common.InvoiceDate,
          formatter: (r: ApiModel.IncomingInvoice) => r.invoiceDate && new Date(r.invoiceDate),
          noWrap: true,
        },
        certifyPersonName: {
          description: TranslationKeys.Common.Receiver,
          formatter: (r: ApiModel.IncomingInvoice) =>
            r.certifyPersonId ? new User(r.certifyPersonId, r.certifyPersonName) : "",
          noWrap: true,
        },
        oCR: {
          description: TranslationKeys.Invoice.No,
          noWrap: true,
          classification: "number",
        },
        dueDate: {
          description: TranslationKeys.Common.Due_Date,
          formatter: (r: ApiModel.IncomingInvoice) => r.dueDate && new Date(r.dueDate),
          noWrap: true,
        },
        amountWithSign: {
          description: TranslationKeys.Common.AmountInclVAT,
          formatter: (r: ApiModel.IncomingInvoice) => new Amount(r.currency, r.amountWithSign),
          alignment: "right",
          noWrap: true,
          summaryValueFormatter: (values: WintSuperkollAPIModel.IncomingInvoice) => (
            <CurrencyValueFormatter cellValue={values.totalAmountSummary} />
          ),
          classification: "amount",
        },
        leftToPay: {
          description: TranslationKeys.Supplier.LeftToPay,
          formatter: (r: ApiModel.IncomingInvoice) => new Amount(r.currency, r.leftToPay),
          alignment: "right",
          className: cssExports.textBlack,
          noWrap: true,
          summaryValueFormatter: (values: WintSuperkollAPIModel.IncomingInvoice) => (
            <CurrencyValueFormatter cellValue={values.totalAmountSummary} />
          ),
          classification: "amount",
        },
        state: {
          description: TranslationKeys.Common.Status,
          formatter: (r: ApiModel.IncomingInvoice) => <IncomingInvoiceStatusTags status={r.state} />,
        },
        isPaid: {
          description: TranslationKeys.Invoice.Paid,
          formatter: (r: ApiModel.IncomingInvoice) => <IncomingInvoicePaymentStatus status={r.paymentStatus} />,
          alignment: "center",
        },
      }}
      filter={filterFunc}
      pagination={"advanced"}
      maxRowCount={10}
      hidePaginationIfSinglePage
      includeSummary
      itemUrl={getItemUrl}
      tableId={TableEnums.TableType.SupplierInvoiceList}
    />
  );
};
export default SupplierInvoiceList;
